module.exports = __webpack_public_path__ + "img/phone-vibrate-fill.3f425112.svg";